/* ============================================
   Nostalgia Bandanas — Custom JS
   ============================================ */

document.addEventListener('DOMContentLoaded', function() {

  // --- Fix cart drawer scroll jump ---
  var savedScroll = 0;
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-testid="cart-drawer-trigger"], cart-icon, a:has(cart-icon)')) {
      savedScroll = window.scrollY;
    }
  }, true);

  document.addEventListener('close', function(e) {
    if (e.target.closest('.cart-drawer__dialog')) {
      requestAnimationFrame(function() {
        window.scrollTo(0, savedScroll);
        requestAnimationFrame(function() {
          window.scrollTo(0, savedScroll);
        });
      });
    }
  }, true);

  // --- Add to Cart Chime Sound + "CLICK HERE TO BUY" notification ---
  var chimeEl = document.getElementById('nb-chime-url');
  if (chimeEl) {
    var chimeUrl = chimeEl.getAttribute('data-url');
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('button[name="add"], .product-form__submit, [data-add-to-cart]');
      if (btn) {
        var audio = new Audio(chimeUrl);
        audio.play().catch(function() {});

        // Show "CLICK HERE TO BUY" notification left of cart icon
        showBuyNotify();
      }
    });
  }



  // --- Block cart icon when cart is empty ---
  document.addEventListener('click', function(e) {
    var cartTrigger = e.target.closest('cart-drawer-component button, cart-drawer-component a, [data-testid="cart-drawer-trigger"], a:has(cart-icon)');
    if (cartTrigger) {
      var bubble = document.querySelector('.cart-bubble');
      if (bubble && bubble.classList.contains('visually-hidden')) {
        e.preventDefault();
        e.stopPropagation();
      }
    }
  }, true);

  // --- "CLICK HERE TO BUY" persistent notification ---
  var buyNotifyCreated = false;
  function showBuyNotify() {
    if (buyNotifyCreated || document.getElementById('nb-buy-notify')) return;
    var cartIconEl = document.querySelector('cart-icon, [data-testid="cart-icon"]');
    if (!cartIconEl) return;

    buyNotifyCreated = true;
    var parent = cartIconEl.closest('cart-drawer-component') || cartIconEl.closest('.header-actions__action') || cartIconEl.parentElement;
    parent.style.position = 'relative';

    var notify = document.createElement('div');
    notify.id = 'nb-buy-notify';
    notify.textContent = 'CLICK HERE TO BUY';
    notify.style.cssText = 'position:absolute;right:100%;top:50%;transform:translateY(-50%);margin-right:8px;z-index:9999;background:#F97316;color:#fff;font-family:Arial,sans-serif;font-size:9px;font-weight:bold;padding:5px 10px;border-radius:4px;cursor:pointer;box-shadow:0 2px 6px rgba(0,0,0,0.3);white-space:nowrap;';
    parent.appendChild(notify);

    notify.addEventListener('click', function() {
      var cartBtn = parent.querySelector('button, a');
      if (cartBtn) cartBtn.click();
    });
  }

  function removeBuyNotify() {
    var existing = document.getElementById('nb-buy-notify');
    if (existing) existing.remove();
    buyNotifyCreated = false;
  }

  // Show on page load if cart has items
  var cartBubble = document.querySelector('.cart-bubble__text-count');
  if (cartBubble && cartBubble.textContent.trim() !== '' && !cartBubble.closest('.hidden')) {
    showBuyNotify();
  }

  // Check if cart has items
  function cartHasItems() {
    var count = document.querySelector('.cart-bubble__text-count');
    var bubble = document.querySelector('.cart-bubble');
    if (!count || !bubble) return false;
    var val = parseInt(count.textContent.trim());
    return !isNaN(val) && val > 0 && !bubble.classList.contains('visually-hidden') && !count.classList.contains('hidden');
  }

  // Watch for cart count changes to show/hide
  var cartIconTarget = document.querySelector('cart-icon, [data-testid="cart-icon"]');
  if (cartIconTarget) {
    var cartIconObserver = new MutationObserver(function() {
      if (cartHasItems()) {
        showBuyNotify();
      } else {
        removeBuyNotify();
      }
    });
    cartIconObserver.observe(cartIconTarget, { childList: true, subtree: true, characterData: true, attributes: true });
  }

  // Also watch the whole header for cart changes (Shopify may replace the cart-icon element)
  var headerGroup = document.getElementById('header-group');
  if (headerGroup) {
    var headerObserver = new MutationObserver(function() {
      if (cartHasItems()) {
        showBuyNotify();
      } else {
        removeBuyNotify();
      }
    });
    headerObserver.observe(headerGroup, { childList: true, subtree: true, characterData: true, attributes: true });
  }

  // Fallback: poll cart API every 2 seconds to catch any missed updates
  setInterval(function() {
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      if (cart.item_count > 0) {
        showBuyNotify();
      } else {
        removeBuyNotify();
      }
    }).catch(function() {});
  }, 2000);

  // --- Custom Cart Drawer Header ---
  var bandanaIconEl = document.getElementById('nb-bandana-icon');
  var bandanaUrl = bandanaIconEl ? bandanaIconEl.getAttribute('data-url') : '';
  var mesoCoinEl = document.getElementById('nb-meso-coin');
  var mesoCoinUrl = mesoCoinEl ? mesoCoinEl.getAttribute('data-url') : '';

  function injectCartHeader() {
    var dialog = document.querySelector('.cart-drawer__dialog[open]');
    if (!dialog) return;
    var cartHeader = dialog.querySelector('.cart-drawer__header');
    if (!cartHeader || cartHeader.querySelector('.nb-cart-header-tab')) return;

    // Check if cart has items by looking for the "Continue shopping" button (empty state)
    var isEmpty = !!dialog.querySelector('.cart-items__empty-button');

    // Force header to have no side padding
    cartHeader.style.cssText += 'padding-left:0!important;padding-right:0!important;padding-inline:0!important;padding-bottom:0!important;';

    var customHeader = document.createElement('div');
    customHeader.style.cssText = 'padding:0;margin:0;width:100%;';

    if (isEmpty) {
      // Cart is empty - close the dialog
      dialog.close();
      return;
    } else {
      // Has items - show item row (price flips to $20 each when 3+ are in cart)
      customHeader.innerHTML =
        '<span class="nb-cart-header-tab">Cart</span>' +
        '<div class="nb-cart-red-line"></div>' +
        '<div class="nb-cart-item-row" style="position:relative;">' +
          '<img src="' + bandanaUrl + '" alt="" class="nb-cart-item-icon">' +
          '<div class="nb-cart-item-info">' +
            '<div class="nb-cart-item-name">Mark of the Beta Bandana</div>' +
            '<div class="nb-cart-item-price"><img src="' + mesoCoinUrl + '" alt="" class="nb-meso-coin"> <span class="nb-cart-unit-price">$25.00 USD Each</span></div>' +
          '</div>' +
          '<button class="nb-cart-remove-btn" aria-label="Remove item">✕</button>' +
        '</div>';

      // Swap unit price to $20 USD when bundle qty (3+) is in the cart
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var totalQty = (cart && cart.items || []).reduce(function(sum, i) { return sum + (i.quantity || 0); }, 0);
          var priceEl = customHeader.querySelector('.nb-cart-unit-price');
          if (priceEl) priceEl.textContent = totalQty >= 3 ? '$20.00 USD Each' : '$25.00 USD Each';
        })
        .catch(function() {});

      // Remove item button - use event delegation to ensure it works
      customHeader.addEventListener('click', function(e) {
        if (e.target.closest('.nb-cart-remove-btn')) {
          e.preventDefault();
          e.stopPropagation();

          // Remove notification immediately
          var buyNotify = document.getElementById('nb-buy-notify');
          if (buyNotify) buyNotify.remove();

          // Close dialog
          dialog.close();

          // Clear cart then navigate
          fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
            .then(function() { window.location.href = window.location.pathname + '?cache=' + Date.now(); });
        }
      });
    }

    cartHeader.appendChild(customHeader);

  }

  // Force cart drawer text to black via inline styles (overrides theme color scheme)
  function forceCartBlackText() {
    var dialog = document.querySelector('.cart-drawer__dialog[open]');
    if (dialog) {
      dialog.style.setProperty('--color-foreground', 'rgb(0, 0, 0)', 'important');
      dialog.style.setProperty('--color-foreground-rgb', '0, 0, 0', 'important');
      dialog.style.setProperty('--color-foreground-heading', 'rgb(0, 0, 0)', 'important');
    }
  }

  // Rename checkout button text
  function renameCheckoutButton() {
    var btn = document.querySelector('.cart-drawer__dialog[open] .cart__checkout-button, .cart-drawer__dialog[open] button[name="checkout"]');
    if (btn && btn.textContent.trim() !== 'BUY ITEM') {
      btn.textContent = 'BUY ITEM';
    }
  }

  // Inject "Secure Checkout via Shopify" under BUY ITEM button
  function injectSecureCheckoutNote() {
    var dialog = document.querySelector('.cart-drawer__dialog[open]');
    if (!dialog) return;
    if (dialog.querySelector('.nb-secure-checkout-note')) return;
    var btn = dialog.querySelector('.cart__checkout-button, button[name="checkout"]');
    if (!btn) return;
    var host = btn.parentElement || btn;
    var note = document.createElement('div');
    note.className = 'nb-secure-checkout-note';
    note.innerHTML = '<svg class="nb-lock-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a5 5 0 0 0-5 5v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1V7a5 5 0 0 0-5-5zm-3 8V7a3 3 0 1 1 6 0v3H9z"/></svg><span>Secure Checkout via Shopify</span>';
    host.insertAdjacentElement('afterend', note);
  }

  // --- Cart drawer customizations ---
  var cartDialog = document.querySelector('.cart-drawer__dialog');
  if (cartDialog) {
    var isApplying = false;

    function applyCartCustomizations() {
      if (!cartDialog.hasAttribute('open') || isApplying) return;
      isApplying = true;
      injectCartHeader();
      forceCartBlackText();
      renameCheckoutButton();
      injectSecureCheckoutNote();
      isApplying = false;
    }

    // Watch for dialog open and content morphs (Shopify re-renders inner content)
    var dialogObserver = new MutationObserver(function() {
      if (cartDialog.hasAttribute('open')) {
        applyCartCustomizations();
      }
    });
    dialogObserver.observe(cartDialog, {
      attributes: true,
      attributeFilter: ['open'],
      childList: true,
      subtree: true
    });
  }

  // --- Product Media Gallery: Carousel with Thumbnails ---
  var grid = document.querySelector('media-gallery .media-gallery__grid');
  if (grid) {
    var items = Array.from(grid.querySelectorAll(':scope > .product-media-container'));
    if (items.length > 0) {
      // Set first item as active
      items[0].classList.add('nb-carousel-active');

      // Build thumbnail strip
      var thumbStrip = document.createElement('div');
      thumbStrip.className = 'nb-gallery-thumbs';

      items.forEach(function(item, i) {
        var img = item.querySelector('.product-media__image');
        if (!img) return;
        var btn = document.createElement('button');
        btn.className = 'nb-gallery-thumb' + (i === 0 ? ' nb-gallery-thumb--active' : '');
        btn.setAttribute('aria-label', 'View image ' + (i + 1));
        var thumbImg = document.createElement('img');
        thumbImg.src = img.src || img.currentSrc;
        thumbImg.alt = img.alt || 'Thumbnail ' + (i + 1);
        btn.appendChild(thumbImg);
        thumbStrip.appendChild(btn);

        btn.addEventListener('click', function() {
          items.forEach(function(el) { el.classList.remove('nb-carousel-active'); });
          thumbStrip.querySelectorAll('.nb-gallery-thumb').forEach(function(t) { t.classList.remove('nb-gallery-thumb--active'); });
          item.classList.add('nb-carousel-active');
          btn.classList.add('nb-gallery-thumb--active');
        });
      });

      grid.parentNode.insertBefore(thumbStrip, grid.nextSibling);

      // Shared function to go to a specific slide
      var currentIndex = 0;
      function goToSlide(idx) {
        if (idx < 0 || idx >= items.length) return;
        currentIndex = idx;
        items.forEach(function(el) { el.classList.remove('nb-carousel-active'); });
        thumbStrip.querySelectorAll('.nb-gallery-thumb').forEach(function(t) { t.classList.remove('nb-gallery-thumb--active'); });
        items[idx].classList.add('nb-carousel-active');
        var activeThumb = thumbStrip.querySelector('[aria-label="View image ' + (idx + 1) + '"]');
        if (activeThumb) activeThumb.classList.add('nb-gallery-thumb--active');
      }

      // Touch swipe support
      var touchStartX = 0;
      var touchEndX = 0;
      grid.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      grid.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        var diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            goToSlide(currentIndex + 1);
          } else {
            goToSlide(currentIndex - 1);
          }
        }
      }, { passive: true });

      // Add LIMITED EDITION badge to 1st, 2nd, and last items only
      items.forEach(function(item, i) {
        if (i === 0 || i === 1 || i === items.length - 1) {
          item.classList.add('nb-has-badge');
          var badge = document.createElement('div');
          badge.className = 'nb-limited-badge';
          badge.textContent = 'LIMITED EDITION';
          item.appendChild(badge);
        }
      });
    }
  }

  // --- Gabe Saga Box Placement ---
  var sagaBox = document.getElementById('nb-gabe-saga-box');
  if (sagaBox) {
    var buyButtons = document.querySelector('.buy-buttons, [class*="buy-buttons"]');
    if (buyButtons) {
      buyButtons.parentNode.insertBefore(sagaBox, buyButtons.nextSibling);
      sagaBox.style.display = 'block';
    }
  }

  // --- FAQ Accordion ---
  document.querySelectorAll('.nb-faq-question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = this.closest('.nb-faq-item');
      var wasActive = item.classList.contains('active');

      // Close all
      document.querySelectorAll('.nb-faq-item').forEach(function(el) {
        el.classList.remove('active');
      });

      // Toggle clicked
      if (!wasActive) {
        item.classList.add('active');
      }
    });
  });

  // --- Scroll Fade-In Animation ---
  var fadeEls = document.querySelectorAll('.nb-fade-in');
  if (fadeEls.length > 0) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('nb-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    fadeEls.forEach(function(el) {
      observer.observe(el);
    });
  }

  // --- Mobile Sticky Add to Cart ---
  var stickyATC = document.querySelector('.nb-sticky-atc');
  var mainATC = document.querySelector('button[name="add"], .product-form__submit');

  if (stickyATC && mainATC) {
    var stickyObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          stickyATC.classList.remove('nb-show');
        } else {
          // Only show on mobile
          if (window.innerWidth <= 768) {
            stickyATC.classList.add('nb-show');
          }
        }
      });
    }, { threshold: 0 });

    stickyObserver.observe(mainATC);

    // Handle resize
    window.addEventListener('resize', function() {
      if (window.innerWidth > 768) {
        stickyATC.classList.remove('nb-show');
      }
    });

    // Sticky button click -> add to cart
    var stickyBtn = stickyATC.querySelector('.nb-btn-cta');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function(e) {
        e.preventDefault();
        mainATC.click();
      });
    }
  }

  // --- Quantity + Countdown under product title ---
  (function initQuantityCountdown() {
    if (document.querySelector('.nb-quantity-countdown')) return;

    var endDate = new Date();
    endDate.setDate(endDate.getDate() + 3);
    endDate.setHours(23, 59, 59, 999);
    var monthDay = (endDate.getMonth() + 1) + '/' + endDate.getDate();

    var wrap = document.createElement('div');
    wrap.className = 'nb-quantity-countdown';
    wrap.innerHTML =
      '<div class="nb-quantity-info">82 of 1,000 Left • EXTENDED Ends on ' + monthDay + '</div>' +
      '<div class="nb-countdown" data-end="' + endDate.getTime() + '">' +
        '<span class="nb-cd-box"><span class="nb-cd-num" data-d>--</span><span class="nb-cd-lbl">days</span></span>' +
        '<span class="nb-cd-box"><span class="nb-cd-num" data-h>--</span><span class="nb-cd-lbl">hrs</span></span>' +
        '<span class="nb-cd-box"><span class="nb-cd-num" data-m>--</span><span class="nb-cd-lbl">min</span></span>' +
        '<span class="nb-cd-box"><span class="nb-cd-num" data-s>--</span><span class="nb-cd-lbl">sec</span></span>' +
      '</div>';

    // Prefer homepage hero (centered under saga box); fall back to product page title
    var homepageHero = document.querySelector('.nb-homepage-hero');
    if (homepageHero) {
      wrap.classList.add('nb-quantity-countdown--centered');
      homepageHero.appendChild(wrap);
    } else {
      var titleH1 = document.querySelector('main h1, .shopify-section h1');
      if (!titleH1) return;
      titleH1.insertAdjacentElement('afterend', wrap);
    }

    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var cd = wrap.querySelector('.nb-countdown');
      var diff = parseInt(cd.dataset.end, 10) - Date.now();
      if (diff < 0) diff = 0;
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      wrap.querySelector('[data-d]').textContent = d;
      wrap.querySelector('[data-h]').textContent = pad(h);
      wrap.querySelector('[data-m]').textContent = pad(m);
      wrap.querySelector('[data-s]').textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  })();

  // --- Bulk 3-pack bundle deal (Buy 3, Save 20%) ---
  // Requires a Shopify discount code "BUNDLE3" (20% off when 3+ in cart)
  // created in Admin > Discounts. Hitting /discount/BUNDLE3 sets the
  // discount cookie so it auto-applies at checkout.
  (function initBundleDeal() {
    if (document.querySelector('.nb-bundle-deal')) return;
    var buyButtons = document.querySelector('.buy-buttons-block');
    if (!buyButtons) return;

    var bandanaIconEl = document.getElementById('nb-bandana-icon');
    var bandanaUrl = bandanaIconEl ? bandanaIconEl.getAttribute('data-url') : '';
    var bandanaImgs = '';
    if (bandanaUrl) {
      bandanaImgs =
        '<span class="nb-bundle-bandanas" aria-hidden="true">' +
          '<img src="' + bandanaUrl + '" alt="">' +
          '<img src="' + bandanaUrl + '" alt="">' +
          '<img src="' + bandanaUrl + '" alt="">' +
        '</span>';
    }

    var deal = document.createElement('button');
    deal.type = 'button';
    deal.className = 'nb-bundle-deal';
    deal.innerHTML =
      '<span class="nb-bundle-left">' +
        bandanaImgs +
        '<span class="nb-bundle-tag">PARTY PACK</span>' +
      '</span>' +
      '<span class="nb-bundle-right">' +
        '<span class="nb-bundle-main">GET 3 FOR $60 (20% OFF)</span>' +
        '<span class="nb-bundle-sub">Adds 3 bandanas to your cart</span>' +
      '</span>';

    // Place directly below the ATC button (inside the buy-buttons block)
    buyButtons.appendChild(deal);

    deal.addEventListener('click', function() {
      if (deal.classList.contains('is-loading')) return;
      deal.classList.add('is-loading');

      // Set quantity to 3 and submit ATC
      // (the "PARTY" automatic discount applies on its own once 3 are in the cart)
      var qtyInput = document.querySelector('.buy-buttons-block input[name="quantity"], input[name="quantity"]');
      var prevQty = qtyInput ? qtyInput.value : null;
      if (qtyInput) {
        qtyInput.value = '3';
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      var atcBtn = document.querySelector('button[name="add"], .product-form__submit');
      if (atcBtn) atcBtn.click();

      // Restore qty input to its prior value so the user isn't stuck at 3
      setTimeout(function() {
        if (qtyInput && prevQty != null) {
          qtyInput.value = prevQty;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        deal.classList.remove('is-loading');
      }, 800);
    });
  })();

  // --- Pre-order save 10% + ships notes below the price ---
  (function initPreorderNote() {
    var priceEl = document.querySelector('product-price');
    if (!priceEl) return;
    if (document.querySelector('.nb-preorder-note')) return;

    var ships = document.createElement('div');
    ships.className = 'nb-ships-note';
    ships.textContent = 'SHIPS TOMORROW';
    priceEl.insertAdjacentElement('afterend', ships);
  })();
});
